<template>
  <div class="prescription">
    <div class="cont">
      <div class="baseInfo bgWhite">
        <p class="nameT">{{ detailData.rectificationName }}</p>
        <div class="msg">
          <span v-if="detailData.section">编码章节：{{ detailData.section }}</span>
          <span v-if="detailData.source">古方追溯：{{ detailData.source }}</span>
          <span v-if="detailData.id">编号：{{ detailData.id }}</span>
          <span v-if="detailData.author">作者：{{ detailData.author }}</span>
          <span v-if="detailData.author">古方年代：{{ detailData.years }}</span>
        </div>
      </div>
      <div class="fangjiCont bgWhite">
        <div class="ywzc">
          <p class="title2">药物组成</p>
          <div class="ycLists"> 
            <span v-for="item in tableData">{{ item.medicineName }}{{ Number(item.dosage) }}{{ item.unit }}</span>
          </div>
        </div>
        <div class="gxzz top20">
          <p class="title2">古籍原文：</p>
          <div class="bg2" v-html="detailData.originalText"></div>
        </div>
        <div class="gxzz top20">
          <p class="title2">功效主治：</p>
          <div class="bg2">{{ detailData.zhuzhi || '无'  }}</div>
        </div>
        <div class="gxzz top20">
          <p class="title2">处方制法：</p>
          <div class="bg2">{{ detailData.method  || '无' }}</div>
        </div>
        <div class="gxzz top20">
          <p class="title2">煎服法：</p>
          <div class="bg2">{{ detailData.yf  || '无' }}</div>
        </div>
        <div class="gxzz top20">
          <p class="title2">注意事项：</p>
          <div class="bg2">{{ detailData.attention || '无' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return {
      currId:'',
      detailData:{
        rectificationName:'',
        section:'',
        source:'',
        author:'',
        years:'',
        id:'',
        attention:'',
        yf:'',
        method:'',
        zhuzhi:'',
        originalText:''
      },
      tableData:[]
    }
  },
  created() { 
    this.currId = this.$route.query.id
    this.getDetail()
  },
  methods:{
    getDetail(){
      let url = "/ancientPrescription/getAncientPrescriptionV2";
      let parmas = {
        id: this.currId
      }; 
      this.$http
        .post(url, parmas)
        .then(res => {
          if (res.data.code == 200) {
            let arr = res.data.data || {};
            this.detailData = Object.assign(this.detailData,arr)
            this.tableData = arr.ancientPrescriptionSlaves || [] 
          }else{
            this.$message.error(res.data.msg);
          }
        })
    }
  },

}
</script>
<style scoped>
.prescription{
  background: #F9F9F9;
  padding: 10px 0;
}
.bgWhite{
  background: #fff;
  border-radius:4px;
  border: 1px solid #F0F0F0;
  padding: 20px;
}
.cont{
  width: 1024px;
  margin: 0 auto;
} 
.baseInfo{
  background: url(../assets/img/bgYp.png) no-repeat 0 0 ;
  background-size: 100% 100%; 
}
.baseInfo .nameT{
  font-size: 16px;
  color: #050505;
  font-weight: bold;
  margin-bottom: 17px;
}
.baseInfo .msg{
  font-size: 14px;
  color: #999;
}
.baseInfo .msg span + span{
  margin-left:40px;
}
.fangjiCont{
  margin-top: 20px;
}
.title2{
  color: #050505;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}
.ycLists{
  display: flex;
  flex-wrap: wrap;
}
.ycLists span{
  border-radius: 4px 4px 4px 4px;
  border: 1px solid rgba(153,153,153,0.28);
  line-height: 26px;
  padding: 0 26px;
}
.ycLists span {
  margin-right: 10px;
  margin-bottom: 10px;
}
.ywzc{
  border-bottom:1px solid #f0f0f0;
  margin: 0 -20px;
  padding: 0 20px;
}
.top20{
  margin-top:20px;
}
.bg2{
  background: rgba(243,245,249,0.5);
  border-radius:4px;
  padding: 15px 20px;
  font-size: 16px;
  color: #333;
}
</style>


// WEBPACK FOOTER //
// src/components/ancPreDetail.vue